export enum PromoBannerBackgroundThemeEnum {
  BACKGROUND_LIGHT = 'BACKGROUND_LIGHT',
  BACKGROUND_DARK = 'BACKGROUND_DARK',
  BACKGROUND_PROMO1 = 'BACKGROUND_PROMO1',
  BACKGROUND_PROMO2 = 'BACKGROUND_PROMO2'
}
